import FieldRenderer from './fieldRenderer';
import React from 'react';

function LinkedInputs({
  fields,
  formId,
  contentArticleFormId,
  requiredList,
  placeholderAsLabels,
  consultant
}) {
  return (
    <div className="formgroup inputs">
      {FieldRenderer.chooseFor(
        fields,
        formId,
        requiredList,
        placeholderAsLabels,
        contentArticleFormId,
        consultant,
        'subgroup'
      )}
    </div>
  );
}

LinkedInputs.propTypes = {
  fields: React.PropTypes.array,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  requiredList: React.PropTypes.array,
  placeholderAsLabels: React.PropTypes.bool,
  consultant: React.PropTypes.object
};

export default LinkedInputs;



// WEBPACK FOOTER //
// ./components/forms/linkedInputs.js